import ScreenSection from 'desktop/components/containers/ScreenSection';
import { useScrollbar } from 'desktop/components/containers/ScrollbarProvider';
import { animateDeviceOut } from 'desktop/animations/animateDeviceOut';
import { animateSimpleDevice } from 'desktop/animations/animateSimpleDevice';
import { animateCarouselIn } from '../../animations/animateCarouselIn';
import { animateCarouselOut } from '../../animations/animateCarouselOut';

const PickupGrabSection = () => {
  const { useScrollReady } = useScrollbar();

  useScrollReady(setupAnimations);

  return <ScreenSection id={'buy-pickup-grab'} />;
};

const setupAnimations = () => {
  const trigger = '#buy-pickup-grab';

  const deviceOut = animateDeviceOut(trigger, '#buy-device-second');
  const simpleDevice = animateSimpleDevice(trigger, '#device-chat');
  const carouselIn = animateCarouselIn(trigger, '.pickup-grab-text');
  const carouselOut = animateCarouselOut(trigger, '.buy-buy-with-click-text');

  return () => {
    deviceOut.kill();
    simpleDevice.kill();
    carouselIn.kill();
    carouselOut.kill();
  };
};

export default PickupGrabSection;
